<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div class='base-code-tree-grid'>
        <dx-tree-list
          ref="refBasecode"
          :height='gridHeight'
          :data-source="basecodeList"
          :autoExpandAll='true'
          :show-borders="true" :showRowLines = 'true'
          :column-auto-width="true"
          :hover-state-enabled = "true"
          key-expr="코드"
          parent-id-expr="상위코드"
          :focused-row-enabled="true"
          :allow-column-resizing="true"
          column-resizing-mode="nextColumn"
          @init-new-row="onInitNewRow"
          @row-inserted='onRowInserted'
          @row-updated='onRowUpdated'
          @row-removed='onRowRemoved'
          @toolbar-preparing='onToolbarPreparing'
          @editor-preparing='onEditorPreparing'
        >
          <DxSearchPanel
            :visible="true"
            placeholder="검색..."
          />
          <DxEditing
            :allow-adding="isAdding"
            :allow-updating="isUPdate"
            :allow-deleting="isUPdate"
            :use-icons="true"
            mode="row"
          />

          <dx-column
            data-field="코드"
            caption="코드"
            sort-order='asc'
            :allowEditing='isIdEdit'
            :allow-sorting="true"
          />
          <dx-column
            data-field="코드명"
            caption="코드명"
            :allow-sorting="true"
          />
          <dx-column
            data-field="설명"
            caption="설명"
            :allow-sorting="false"
          />
          <dx-column
            data-field="상위코드"
            caption="상위코드"
            :allow-sorting="false"
            :allowEditing='false'
          />
          <dx-column
            data-field="사용유무"
            caption="사용유무"
            :allow-sorting="false"
            width='150'
          />
          <dx-column
            data-field="삭제유무"
            caption="삭제유무"
            :allow-sorting="false"
            width='150'
          />
          <DxColumn
            caption="수정일"
            :allowEditing='false'
            :allow-sorting="false"
            data-field="updatedTime"
            dataType= 'date'
            format='yyyy-MM-dd'
            alignment='center'>
          </DxColumn>
          <DxColumn
            caption="등록일"
            :allowEditing='false'
            :allow-sorting="false"
            data-field="createdTime"
            dataType= 'date'
            format='yyyy-MM-dd'
            alignment='center'>
          </DxColumn>
          <DxScrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <DxPaging :enabled="false"/>
        </dx-tree-list>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import { DxTreeList, DxColumn, DxSearchPanel, DxScrolling, DxPaging, DxEditing } from 'devextreme-vue/tree-list'
import axios from 'axios'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      selectedIndex: 0,
      basecodeList: null,
      gridHeight: null,
      nodeExpandBtn: null,
      isIdEdit: false
    }
  },
  components: {
    Loading,
    DxTreeList,
    DxColumn,
    DxSearchPanel,
    DxScrolling,
    DxPaging,
    DxEditing
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }

    this.refreshbasecodeList()
  },
  mounted () {
    console.log(screen.height)
    this.gridHeight = (screen.height - 180) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    isAdding (e) {
      if (e.row.data.상위코드 === null) {
        return true
      }
      return false
    },
    isUPdate (e) {
      if (e.row.data.상위코드 === null) {
        return false
      }
      return true
    },
    onEditorPreparing (e) {
      if (e.dataField === '코드명' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    onInitNewRow (e) {
      console.log(e)
      // if (e.data.상위코드 === '0' || e.data.상위코드 === 0) {
      //   e.data.상위코드 = null
      // }
      e.data.사용유무 = true
      e.data.삭제유무 = false
    },
    onRowInserted (row) {
      console.log(row)
      row.data.updatedTime = row.data.createdTime = this.$_appLib.getToday()
      row.data.updatedId = row.data.createdId = this.userInfo.userId
      if (row.data.상위코드 === '0' || row.data.상위코드 === 0) {
        row.data.상위코드 = null
      }

      this.$_sp.runInsertSqlProc('공통코드', null, [this.$_appLib.deleteUnderlineKey(row.data)])
        .then((data) => {
          this.$snotify.info('추가되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowRemoved (row) {
      console.log(row)
      const self = this.$_sp.runDeleteSqlProc('공통코드', [{ 코드: row.data.코드 }])
      const child = this.$_sp.runDeleteSqlProc('공통코드', [{ 상위코드: row.data.코드 }])
      axios.all([self, child])
        .then(axios.spread((...reponse) => {
          this.$snotify.info('삭제되었습니다.')
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowUpdated (row) {
      console.log(row)
      row.data.updatedId = this.userInfo.userId
      let array = []
      array.push(this.$_appLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('공통코드', ['코드'], null, array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            icon: 'chevronup',
            type: 'default',
            text: '노드 축소',
            focusStateEnabled: true,
            onInitialized: (args) => {
              this.nodeExpandBtn = args.component
            },
            onClick: (args) => {
              console.log(args)
              let vm = this
              if (this.nodeExpandBtn.option().text === '노드 축소') {
                this.$refs.refBasecode.instance.forEachNode(function (node) {
                  vm.$refs.refBasecode.instance.collapseRow(node.key)
                })
                this.nodeExpandBtn.option({ icon: 'chevrondown', text: '노드 확장' })
              } else {
                this.$refs.refBasecode.instance.forEachNode(function (node) {
                  vm.$refs.refBasecode.instance.expandRow(node.key)
                })
                this.nodeExpandBtn.option({ icon: 'chevronup', text: '노드 축소' })
              }
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '갱신',
            icon: 'refresh',
            focusStateEnabled: true,
            onClick: (args) => {
              this.refreshbasecodeList()
            }
          }
        }
      )
    },
    refreshbasecodeList () {
      this.isLoading = true

      this.$_sp.runFindProc('spFindAllBaseCodeByNoScode', {})
        .then((data) => {
          this.basecodeList = this.$_.sortBy(this.$_sp.MakeModel(data), '코드')

          // console.log(this.basecodeList)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.base-code-tree-grid{
  .dx-treelist-addrow-button {
    display: block;
  }
}

</style>
